import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventUnitFields from './EventUnitFields'

export const EventUnitEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <EventUnitFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default EventUnitEdit
